import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import { HireAppUser, hireAppUser } from "./user";

import {
  MeJobSlotDataDocument,
  MeJobSlotDataQuery,
  RoleType,
} from "@hire/schema";
import { useAnalytics } from "@otta/shared-components";

const calculatePlan = (
  user: HireAppUser<NonNullable<MeJobSlotDataQuery["me"]>>
) => {
  if (user.__typename !== "CurrentCompanyRecruiter") {
    return undefined;
  }

  if (user.currentCompany?.isPro) {
    return "pro";
  } else if ((user.currentCompany?.jobSlotData?.paid ?? 0) > 0) {
    return "core";
  } else {
    return "free";
  }
};

const getUserProperties = (
  user: HireAppUser<NonNullable<MeJobSlotDataQuery["me"]>>
) => ({
  role:
    user.__typename === "CurrentCompanyRecruiter"
      ? RoleType.CompanyRecruiter
      : RoleType.Admin,
  company: user.currentCompany?.id,
  proTier: user.currentCompany?.isPro,
  plan: calculatePlan(user),
  coreCohort:
    user.__typename === "CurrentCompanyRecruiter"
      ? user.currentCompany?.jobSlotData?.cohort
      : undefined,
});

export function useCookiebot() {
  const { data } = useQuery(MeJobSlotDataDocument);

  const user = hireAppUser(data?.me);

  useEffect(() => {
    function listener() {
      if (data?.me && typeof window.Cookiebot?.hide === "function") {
        window.Cookiebot?.hide();
      }
    }

    window.addEventListener("CookiebotOnDialogDisplay", listener);

    listener();

    return () => {
      window.removeEventListener("CookiebotOnDialogDisplay", listener);
    };
  }, [data?.me]);

  useAnalytics(user, getUserProperties, {
    enabled: import.meta.env.PROD,
  });
}
